import { React, useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql,useApolloClient } from '@apollo/client';
//import FirmSubUsers from './FirmSubUsers';
//import ThemeContext from "../../context/ThemeContext";
import ThemeContext from "../../../../context/ThemeContext";
import UserContext from "../../../../context/UserContext";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from "primereact/inputtext";
import { Link, useNavigate } from "react-router-dom";
import { TabView, TabPanel } from 'primereact/tabview';
import { RadioButton } from "primereact/radiobutton";
import { Fieldset } from 'primereact/fieldset';
import { Divider } from 'primereact/divider';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { PrimeReactProvider } from "primereact/api";
import { Dialog } from 'primereact/dialog';
//import HtlAgnSeaReduction from "./HtlAgnSeaReduction";
//import HtlAgnSeasonPriceEdit from "./HtlAgnSeasonPriceEdit";
import { ProgressSpinner } from 'primereact/progressspinner';
//import HtlResRoomAdd from "./HtlResRoomAdd";
//import HtlResRoomGuestMatch from "./HtlResRoomGuestMatch";




import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../lang/LangGlb';
import HtlHotelRoomClassCoop from "../../../htl/hoteladm/accommodation/roomclass/HtlHotelRoomClassCoop";

import CustBookEdit from "./CustBookEdit";
import CusTripEdit from "./CusTripEdit";

const GET_POST = gql`
  query MyQuery12(
    
    $contIdSeq: Int!

  ) {
    tbl_customer(
     
      where: {
        id_seq: { _eq: $contIdSeq }
        
      }
    ) {
        
      id_seq
      name
      lastname
      mail_adress
      PHONE
      DEALER
   
 
    }
  }
`;

const GET_ROOMS = gql`
  query GetRooms(
   
    $contIdSeq: Int
  ) {
    tbl_trip_raport(
      where: {
       
        ust_id_seq: { _eq: $contIdSeq },
        
      },
      order_by: { id_seq: desc } 
    ) {   
        ust_id_seq
       id_seq
       date
       trip_date
       result
       notes
       notes_2
       dealer
       status

    

    }
  }
`;

const GET_GUEST_LIST = gql`
query MyQuery(
    $resMidId: Int  

    ) {
      tbl_rez_guest_mid_list(where: {
            rez_mid_id: {_eq: $resMidId}
            
          
       
    }) {
       
       rez_top_id
       rez_mid_id
       rez_room_id
       get_res_guest_room_mach_o {
        room_type
        get_room_name {
          r_type_name
        }       
      }
       guest_id
       profile_id
       title
       name
       last_name
       age
       country
       guest_type

       
    

  } 
  
}
`;

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;

const GET_PER_DEFS = gql`
  query GetPerDefs($firmMainCode: String, 
                   $firmSubCode: String,
                   $contIdSeq: Int) {
    tbl_cont_per_def(where: {
      firm_main_code: { _eq: $firmMainCode }, 
      firm_sub_code: { _eq: $firmSubCode }
      cont_id: { _eq: $contIdSeq }
    }) {
      id_seq
      period
      start_date
      end_date
      min_stay
      release
    }
  }
`;

const GET_PER_BASE = gql`
  query GetPerBase(
    $firmMainCode: String, 
    $firmSubCode: String,
    $contIdSeq: Int
  ) {
    tbl_cont_per_base(
      where: {
        firm_main_code: { _eq: $firmMainCode }, 
        firm_sub_code: { _eq: $firmSubCode },
        cont_id: { _eq: $contIdSeq }
      },
      order_by: { room_type: asc } 
    ) {   
      per_id
      room_type
      get_room_name {
        r_type_name
      }
      base_price
      period
    }
  }
`;



const GET_HTL_SEA = gql`
  query GetHtlSea(
    $firmMainCode: String
    $firmSubCode: String
    
  ) {
    tbl_htl_season(order_by: { id_seq: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
       
      }
    ) {
     
        id_seq
        start_date
        end_date
        desc
        active
       
    }
  }
`;


const GET_HTL_PER = gql`
  query GetHtlSea(
    $firmMainCode: String
    $firmSubCode: String
    $htlSeaIdSeq: Int
    
  ) {
    tbl_htl_period(order_by: { id_seq: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
        sea_id_seq: { _eq: $htlSeaIdSeq }
       
      }
    ) {
     
        id_seq
        sea_id_seq
        period
        start_date
        end_date
        release
        min_stay
       
    }
  }
`;





const GET_TBL_CONT_PER_DEF = gql`
  query GetTblContPerDef(
        $firmMainCode: String,
        $firmSubCode: String,
        $contIdSeq: Int
        ) {
    tbl_cont_per_def(where: {
                firm_main_code: { _eq: $firmMainCode }, 
                firm_sub_code: { _eq: $firmSubCode },
                cont_id: { _eq: $contIdSeq }
             }) {
      id_seq
      cont_id
      firm_main_code
      firm_sub_code
      start_date
      end_date
      period
      min_stay
      release
      get_room_types {
        r_class_code
        r_type_code
      }
    
    }
  }
`;





const DELETE_PER_PRICE = gql`
mutation DeleteContBasePrice(
  $contIdSeq: Int
  $firmMainCode: String
  $firmSubCode: String
) {
  delete_tbl_cont_per_price(
    where: {
      firm_main_code: { _eq: $firmMainCode }
      firm_sub_code: { _eq: $firmSubCode }
      cont_id: { _eq: $contIdSeq }
    }
  ) {
    affected_rows
  }
}
`;

const DELETE_PER_GRP = gql`
mutation DeleteContPerGrp(
  $contIdSeq: Int
  $firmMainCode: String
  $firmSubCode: String
) {
  delete_tbl_cont_per_grp(
    where: {
      firm_main_code: { _eq: $firmMainCode }
      firm_sub_code: { _eq: $firmSubCode }
      cont_id: { _eq: $contIdSeq }
    }
  ) {
    affected_rows
  }
}
`;



const UPDATE_CONT = gql`
mutation UpdateContract(
 
  $firmMainCode: String
  $firmSubCode: String
 

  $startDate: date
  $endDate: date
  $contIdSeq: Int
  $resAccRoom: Int
  $resAccGuest: Int

) {
  update_tbl_rez_mid(
    where: {
      firm_main_code: { _eq: $firmMainCode }
      firm_sub_code: { _eq: $firmSubCode }
      rez_mid_id: { _eq: $contIdSeq }
    },
    _set: {
    
       
      sty_start_date: $startDate,
      sty_end_date: $endDate,
      accmom_room: $resAccRoom,
      accom_guest: $resAccGuest,
 
    
    }
  ) {
    affected_rows
  }
}
`;


























const CusTrip = () => {
    const { users } = useContext(UserContext);
    const { firmcode, subfirmcode, usertype, userLang, usernames } = users;
    const { id_seq } = useParams();
    const {varCode3, setVarCode3} = useContext(ThemeContext);
    const {varCode4, setVarCode4} = useContext(ThemeContext);
    const {varCode5, setVarCode5} = useContext(ThemeContext);
    const {varCode6, setVarCode6} = useContext(ThemeContext);
    const {varCode7, setVarCode7} = useContext(ThemeContext);
    const {varCode8, setVarCode8} = useContext(ThemeContext);
    const {varCode9, setVarCode9} = useContext(ThemeContext);
    const {varCode10, setVarCode10} = useContext(ThemeContext);
    const {varCode14, setVarCode14} = useContext(ThemeContext);
    const {varCode15, setVarCode15} = useContext(ThemeContext);
    const [someCondition, setSomeCondition] = useState(false);
   
    
    const firmMainCode = firmcode;
    const firmSubCode = subfirmcode;
    const username = usernames;
    const intl = useIntl();
    const currentLocale = userLang || localStorage.getItem('lang') || 'en';
  
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(0);
    const [activeTabS, setActiveTabS] = useState(9);
  
    const handleTabChange = (index) => {
      setActiveTab(index);
    };
  
    const handleTabChangeS = (index) => {
      setActiveTabS(index);
    };
  
    const { loading, error, data, refetch } = useQuery(GET_POST, {
      variables: { contIdSeq: varCode4 },
    });
  
    const ownFirmMainCode = firmcode;
    const ownFirmSubCode = subfirmcode;
    const ownFirmSubType = usertype;
  
   // const [UpdateContract] = useMutation(UPDATE_CONT);
    
    const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2);
  

   
   
   
   
  
  const { loading: tblContPerDefLoading, error: tblContPerDefError, data: tblContPerDefData } = useQuery(GET_TBL_CONT_PER_DEF);
    



    // useMutation'ı bileşen içinde kullanın
    
 
  
  
    const firmData = data && data.tbl_customer ? data.tbl_customer[0] : null;

    const [contIdSeq, setContIdSeq] = useState(firmData ? firmData.cont_id :"");
    const [contSeaIdSeq, setContSeaIdSeq] = useState(firmData ? firmData.rez_mid_id :"");
    const [htlSeaIdSeq, setHtlSeaIdSeq] = useState(firmData ? firmData.rez_top_id :"");
    const [startDate, setStartDate] = useState(firmData ? new Date(firmData.sty_start_date): new Date());
    const [endDate, setEndDate] = useState(firmData ? new Date(firmData.sty_end_date) : new Date());
    const [resTopId, setResTopId] = useState(firmData ? firmData.rez_top_id :"");
    const [resMidId, setResMidId] = useState(firmData ? firmData.rez_mid_id :"");
    const [resAccRoom, setResAccRoom] = useState(firmData ? firmData.name :"");
    const [resAccGuest, setResAccGuest] = useState(firmData ? firmData.lastname :"");
    const [resMail, setResMail] = useState(firmData ? firmData.mail_adress :"");
    const [brokers, setBrokers] = useState(firmData ? firmData.DEALER :"");
    
    const [sourceType, setSourceType] = useState(firmData ? firmData.PHONE :"");
    const [PriceId, setPriceId] = useState(firmData ? firmData.cont_id :"");
    
    
    
  
    
    
    const [DeleteContBasePrice] = useMutation(DELETE_PER_PRICE);
   

    const [basePeriod, setBasePeriod] = useState();
    const [roomType, setRoomType] = useState();
    const [basePrice, setBasePrice] = useState();
    const [basePricetrg, setBasePriceTrg] = useState(1);
    const [idSeqtrg, setIdSeqTrg] = useState();

    const [baseStartPrice, setBaseStartPrice] = useState();
   

   

    
   const { loading: loadingRuleSub, error: perRuleSubError, data: perRuleSubData, refetch: refetchRuleSub } = useQuery(GET_ROOMS, {
    variables: {  contIdSeq: varCode4 },
  });

  const firmData2 = perRuleSubData && perRuleSubData.tbl_trip_raport;

  const { loading: loodinggue, error:errorgue, data: datague, refetch: refechgue } = useQuery(GET_GUEST_LIST, {
    variables: { resMidId: varCode4},
  });

  const firmData5 = datague && datague.tbl_trip_raport;

 

  


  
    console.log("Firm Data:", firmData);

    const { loading: htlseaLoading, error: htlseaError, data: htlseaData } = useQuery(GET_HTL_SEA, {
        variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode},
      });

      const { loading: htlperLoading, error: htlperError, data: htlperData } = useQuery(GET_HTL_PER, {
        variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode, htlSeaIdSeq: htlSeaIdSeq},
      });

      const { loading: htlperroomLoading, error: htlperroomError, data: htlperroomData } = useQuery(GET_TBL_CONT_PER_DEF, {
        variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode, contIdSeq: contIdSeq},
      });




     
      

     

      

     

    

  const cont_detail_tab = messages[currentLocale].cont_detail_tab;

  const [tableData, setTableData] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);

  
 const { loading: loadingPerDefs, error: perDefError, data: perDefsData, refetch: refetchPerDefs2  } = useQuery(GET_PER_DEFS, {
    variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode, contIdSeq: contIdSeq},
  });
 
 //const { loading: loadingPerBase, data: perBaseData, refetch: refetchPerDefs  } = useQuery(GET_PER_BASE);
 const { loading: loadingPerBase, error: perBaseError, data: perBaseData, refetch: refetchPerDefs  } = useQuery(GET_PER_BASE, {
    variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode, contIdSeq: contIdSeq},
  });

  const [UpdateContract] = useMutation(UPDATE_CONT);



  

  const getDatesBetween = (startDate, endDate) => {
    console.log("Start Date:", startDate);
    console.log("End Date:", endDate);
    
    const dates = [];
    let currentDate = new Date(startDate);
    
    console.log("Original End Date:", endDate);
    
    endDate = new Date(endDate); // endDate'i kopyalayarak değişikliklerden etkilenmesini engelle
    endDate.setDate(endDate.getDate() + 1); // endDate'i bir gün sonraya ayarla
    
    console.log("Updated End Date:", endDate);
    
    while (currentDate < endDate) {
        console.log("Current Date:", currentDate);
        dates.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
    }
    
    console.log("Dates result:", dates);
    
    return dates;
};

  const getDatesBetween2 = (startDate, endDate) => {
    const dates = [];
    let currentDate = new Date(startDate);
    
    while (currentDate <= endDate) {
      dates.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    
    return dates;
  };

  const [displayDialog, setDisplayDialog] = useState(false);
  const [displayDialog2, setDisplayDialog2] = useState(false);
  const [loadingpop, setLoadingpop] = useState(false);
   



  const handleUpdateIdSeq3 = async () => {
    try {
      const { data } = await updateIdSeq2({
        variables: {
          type: 'DPRIC', 
        },
      });
      const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
      console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
      return updatedIdSeq;
    } catch (error) {
      console.error('Güncelleme hatası:', error);
      throw error; // Hata durumunda dışarı at
    }
  };

 

  const handlePerPriceDelete = () => {
    DeleteContBasePrice({
      variables: {
        contIdSeq: contIdSeq,       
        firmMainCode: firmMainCode,
        firmSubCode: firmSubCode,
      
       

        
      },
    })
      .then(() => {
        window.alert("Contract Per Deleted successfully!");
       
      
      })
      .catch((error) => {
        console.error("Error Deleted Cont Per Price:", error);
      });
  };


  const handleUpdateCont = () => {
    UpdateContract({
      variables: {   
       
        
        firmMainCode: firmMainCode,
        firmSubCode: firmSubCode,    
        startDate: new Date(startDate).toLocaleDateString(),
        endDate: new Date(endDate).toLocaleDateString(),
        resAccRoom: resAccRoom,
        resAccGuest: resAccGuest,
        contIdSeq: contIdSeq

      },
    })
      .then(() => {
        window.alert("Guest updated successfully!");
        refetchRuleSub();
       
       
       
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  };



    

    useEffect(() => {
        if (firmData) {  
               

          setContIdSeq(varCode4);
       // setContIdSeq(firmData.cont_id);
          setContSeaIdSeq(firmData.rez_mid_id);
          setHtlSeaIdSeq(firmData.rez_top_id);
          setStartDate(new Date(firmData.sty_start_date));
          setEndDate(new Date(firmData.sty_end_date));
          setResTopId(firmData.rez_top_id);
          setResMidId(firmData.rez_mid_id);
          setResAccRoom(firmData.name);
          setResAccGuest(firmData.lastname);
          setPriceId(firmData.cont_id);
          setSourceType(firmData.PHONE);
          setResMail(firmData.mail_adress);
          setBrokers(firmData.DEALER);
          refetch();  

          
          
          
        }
      }, [firmData]);

      const { xloading, xdata } = useQuery(GET_HTL_SEA, {
        variables: {
          firmMainCode: firmMainCode,
          firmSubCode: firmSubCode
          
        },
      });

   



      

      const [selectedRowData, setSelectedRowData] = useState(null);
      

      const onEditButtonClick = (rowData) => {
       // setSelectedRowData(rowData);
        setDisplayDialog(true);
        setVarCode4(contIdSeq);
        setVarCode3(sourceType);
        setVarCode7(resTopId);
        setVarCode15(PriceId);
        setVarCode10(brokers);
        
        
        // handleEditButtonClick'i çağırırken doğru parametreleri geçir
     //   handleEditButtonClick(rowData);
      };

      const onEditButtonClick3 = (rowData) => {
        // setSelectedRowData(rowData);
         setDisplayDialog2(true);
         setVarCode4(contIdSeq);
         setVarCode7(resTopId);
         setVarCode15(PriceId)
         
         
         // handleEditButtonClick'i çağırırken doğru parametreleri geçir
      //   handleEditButtonClick(rowData);
       };

      const onEditButtonClick2 = (rowData) => {
        // setSelectedRowData(rowData);
         
        
        setVarCode4(contIdSeq);
        setVarCode3(sourceType);
        setVarCode8(0);
        setVarCode15(PriceId);
        setVarCode10(brokers);
               
         setDisplayDialog(true);


       };



   


      const handleUpdateIdSeq2 = async () => {
        try {
          const { data } = await updateIdSeq2({
            variables: {
              type: 'MFIRM', 
            },
          });
          const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
          console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
          setContSeaIdSeq(updatedIdSeq); 
          
          
         
         // setVarCode(updatedIdSeq.toString());  
          console.log(contSeaIdSeq);         
           
          
        } catch (error) {
          console.error('Güncelleme hatası:', error);
        }
      };


      const handleUpdateIdSeq = async () => {
        const requiredFields = ['htlSeaIdSeq', 'baseStartPrice' ]; // Required fiels
        const customFieldNames = {
            htlSeaIdSeq: "Hotel Sezon Kodu",
            baseStartPrice: "Base Price"
        
    
        };
        const emptyFields = getEmptyFields(requiredFields, customFieldNames); // Boş alanları kontrol et
      
        if (emptyFields.length === 0) {
          try {
            const { data } = await updateIdSeq2({
              variables: {
                type: 'MFIRM', 
              },
            });
            const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
            console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
            setContSeaIdSeq(updatedIdSeq); 
            setIdSeqTrg(updatedIdSeq);
            
            console.log(contSeaIdSeq);
            // setVarCode(updatedIdSeq.toString());  
          } catch (error) {
            console.error('Güncelleme hatası:', error);
          }
        } else {
          
          const emptyFieldsMessage = `Lütfen Hotel Sezonu & Base Price doldurun: ${emptyFields.join(', ')}`;
         // console.log(emptyFieldsMessage);
          window.alert(emptyFieldsMessage);
        }
      };
      
      const validateForm = (requiredFields, customFieldNames) => {
        // Tüm gerekli alanları kontrol et
        for (const field of requiredFields) {
          if (!eval(field)) {
            return false;
          }
        }
      
        return true;
      };
      
      const getEmptyFields = (requiredFields, customFieldNames) => {
        const emptyFields = [];
      
        // Boş olan alanları bul
        for (const field of requiredFields) {
          if (!eval(field)) {
            emptyFields.push(customFieldNames[field]);
          }
        }
      
        return emptyFields;
      };
    

      useEffect(() => {
        // varCode4 değiştiğinde yapılacak işlemler
        setContIdSeq(varCode4);
        setVarCode4(varCode4);
        setSomeCondition(true);
        console.log("var:", varCode4)
        
        // refetch fonksiyonunu çağırma koşullarına bağlı olarak
        if (someCondition) {
          refetch();
       
        }
      }, [varCode4, setContIdSeq, someCondition]);


    
      
      
      

    
      const handleDialogSave = () => {
        // Burada dialog penceresinden alınan yeni değerleri kullanarak ilgili işlemleri yapabilirsiniz.
        // Örneğin, bu değerleri bir API'ye gönderebilir ve tabloyu güncelleyebilirsiniz.
        
        // Değişiklikleri uyguladıktan sonra dialog penceresini kapatın
        setDisplayDialog(false);
      };
    
      const handleDialogCancel = () => {
       
        
        refetchRuleSub();
        setSelectedRowData(null);
        setDisplayDialog(false);  
        refetch();
        
        
        refetchPerDefs(); 

      };

      const handleDialogCancel2 = () => {
       
        
        
        setDisplayDialog2(false);  
        refechgue();
    
      };
      
      


         

              useEffect(() => {
                if (htlseaData && htlSeaIdSeq) {
                  const selectedSea = htlseaData.tbl_htl_season.find(sea => sea.id_seq === htlSeaIdSeq);
                  
                  if (selectedSea) {
                    setStartDate( new Date(selectedSea.start_date));              
                    setEndDate( new Date(selectedSea.end_date));
                  }
              
                  console.log("start date:", selectedSea ? selectedSea.start_date : null);
                }
              }, [htlSeaIdSeq, htlseaData]);
          

         /* const htlSeaItems = htlseaData && htlseaData.tbl_htl_season
          ? htlseaData.tbl_htl_season.map(item => ({
              label: item.desc,
              value: item.id_seq,
              name: item.desc, 
            }))
          : [];*/

          const htlSeaItems = htlseaData && htlseaData.tbl_htl_season
          ? htlseaData.tbl_htl_season.map(item => ({
              label: (
                <div>
                  <div>{item.desc}</div>
                  <div>Start Date: {new Date(item.start_date).toLocaleDateString('en-GB')}</div>
          <div>End Date: {new Date(item.end_date).toLocaleDateString('en-GB')}</div>
                </div>
              ),
              value: item.id_seq,
            }))
          : [];
  
    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;
  
    return (
        <>
          <Fieldset>
            <div className="flex">
              <div className="mr-2 w-1/8">
                <label htmlFor="firmType" className="block font-medium text-gray-700">
                  {"Customer Id"}
                </label>
                <InputNumber
                  inputId="integeronly"
                  useGrouping={false}
                  value={contIdSeq}
                  onValueChange={(e) => setContIdSeq(e.value)}
                  className="w-full h-11 border-gray-300 rounded-md"
                  readOnly
                />                
              </div>

       

              <div className="mr-2 w-1/8">
                <label htmlFor="firmType" className="block font-medium text-gray-700">
                  {"Name"}
                </label>
                <InputText
                  inputId="integeronly"
                  useGrouping={false}
                  value={resAccRoom}
                  onValueChange={(e) => setResAccRoom(e.value)}
                  className="w-full h-11 border-gray-300 rounded-md"
                 
                />                
              </div>

              <div className="mr-2 w-1/8">
                <label htmlFor="firmType" className="block font-medium text-gray-700">
                  {"Last Name"}
                </label>
                <InputText
                  inputId="integeronly"
                  useGrouping={false}
                  value={resAccGuest}
                  onValueChange={(e) => setResAccGuest(e.value)}
                  className="w-full h-11 border-gray-300 rounded-md"
                 
                />                
              </div>

            

   

              <div className="mr-2 w-1/8">
                <label htmlFor="firmType" className="block font-medium text-gray-700">
                  {"Phone"}
                </label>
                <InputText
                  inputId="integeronly"
                  useGrouping={false}
                  value={sourceType}
                  onValueChange={(e) => setResAccGuest(e.value)}
                  className="w-full h-11 border-gray-300 rounded-md"
                 
                />                
              </div>
      
              <div className="mr-2 w-1/8">
                <label htmlFor="firmType" className="block font-medium text-gray-700">
                  {"Mail"}
                </label>
                <InputText
                  inputId="integeronly"
                  useGrouping={false}
                  value={resMail}
                  onValueChange={(e) => setResMail(e.value)}
                  className="w-full h-11 border-gray-300 rounded-md"
                 
                />                
              </div>

 


  <button
    className="bg-violet-900 h-10 mt-6 ml-4 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
    onClick={onEditButtonClick2}
  >
    {"New Inspection Trip"}
  </button>
            </div>
          

            <div>
  
  <Dialog visible={displayDialog} style={{ width: '72vw' }} onHide={handleDialogCancel} header={'Inspection Trip Details'}>
    <div className={`modal-backdrop bg-slate-600  ${displayDialog ? 'block' : 'hidden'}`}></div>
    <div>
      <p>
   <CusTripEdit/>
      </p>
    </div>
  </Dialog>
  </div>

      
      

          </Fieldset>
      
          <TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTab} onTabChange={(e) => handleTabChange(e.index)}>
           <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Customer Inspection Trip List"}
            </span>
          }
          className="ml-5 flex"
        >
      <div>
  
      <DataTable
         value={firmData2}
         scrollable 
         scrollHeight="250px" 
         loading={loadingRuleSub}
         stickyHeader
         stickyTopAt=".layout-topbar"
        

        >
           <Column field="ust_id_seq"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Cust Id"}</span>}
           style={{ textAlign: 'left', width: '7rem' }}
          >
          </Column>

          <Column field="id_seq"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Call Id"}</span>}
           style={{ textAlign: 'left', width: '7rem' }}
          >
          </Column>

        
      
      
       
       

       <Column
           field="date"
           header={<span className="font-bold text-sm text-gray-900">{"Raport Date"}</span>}
           body={(rowData) => {
           const dateTimeString = rowData.date;
           const dateObj = new Date(dateTimeString);
           const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
           const formattedDate = `${dateObj.toLocaleDateString('en-GB', options)} `;
           

          return (
           <div className="text-sm">
           {formattedDate}
           </div>
            );
           }}
          style={{ textAlign: 'left', width: '10rem' }}
           />

<Column
           field="trip_date"
           header={<span className="font-bold text-sm text-gray-900">{"Trip Date"}</span>}
           body={(rowData) => {
           const dateTimeString = rowData.trip_date;
           const dateObj = new Date(dateTimeString);
           const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
           const formattedDate = `${dateObj.toLocaleDateString('en-GB', options)} `;
           

          return (
           <div className="text-sm">
           {formattedDate}
           </div>
            );
           }}
          style={{ textAlign: 'left', width: '10rem' }}
           />

      

          <Column field="notes"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Trip Note"}</span>}
           style={{ textAlign: 'left', width: '37rem' }}
          >
          </Column>

          <Column field="dealer"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Broker"}</span>}
           style={{ textAlign: 'left', width: '9rem' }}
          >
          </Column>
        

          <Column field="status"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Status"}</span>}
           style={{ textAlign: 'left', width: '9rem' }}
          >
          </Column>
          



          <Column
          header={<span className="font-bold text-sm text-gray-900">{"detail"}</span>}
          body={(rowData) => (
            <button
              onClick={() => {               
            setVarCode8(rowData.id_seq);  
           
            
            onEditButtonClick();
           
              
                
              }}
              className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
              </svg>
            </button>
          )}
          style={{ textAlign: 'center', width: '6rem' }}
        ></Column>
    
        </DataTable>

  
 </div>

 

              </TabPanel>
             

          
            
          </TabView>
      
          
        </>
      );
      
  };
  
  export default CusTrip;

 


      
  